import { Component } from "@angular/core";
import { ROUTE_ANIMATIONS_ELEMENTS } from "@app/core";
import { MatToolbar } from "@angular/material/toolbar";
import { RouterLinkActive, RouterLink } from "@angular/router";
import {
  MatCard,
  MatCardHeader,
  MatCardAvatar,
  MatCardTitle,
  MatCardSubtitle
} from "@angular/material/card";
import { NgClass } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-setup-home",
  templateUrl: "./setup-home.component.html",
  styleUrls: ["./setup-home.component.scss"],
  imports: [
    MatToolbar,
    RouterLinkActive,
    RouterLink,
    MatCard,
    NgClass,
    MatCardHeader,
    MatCardAvatar,
    MatCardTitle,
    MatCardSubtitle,
    TranslatePipe
  ]
})
export class SetupHomeComponent {
  public routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor() {}
}
